let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gipQq")).then(() => parcelRequire('3ABrQ'));